import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export const MuiPaper = (theme: Theme): Partial<Components> => ({
  MuiPaper: {
    styleOverrides: {
      root: {
        '& a': {
          color: theme.palette.brand.main,
          textDecoration: 'none',
        },
        backgroundImage: 'unset',
        backgroundColor: theme.palette.common.white,
        '& .tableHeaderWrapper': {
          padding: '12px',
          borderBottom: `1px solid ${theme.bdColors.paleBlue}`,
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          [theme.breakpoints.down('lg')]: {
            flexWrap: 'wrap',
          },
          [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            '& .tableHeaderWrapper--left': {
              flexDirection: 'column',
              '& > .MuiBox-root:first-of-type': {
                paddingBottom: '8px',
                paddingRight: '0',
              },
            },
          },
          '& .searchWrapper': {
            justifyContent: 'flex-start',
            flex: '1',
            paddingRight: '12px',
          },
          '&--left': {
            display: 'flex',
            [theme.breakpoints.down('lg')]: {
              width: '100%',
            },
          },
          '&--right': {
            display: 'flex',
            '& button.MuiButton-root': {
              fontSize: '0.875rem',
              padding: '0',
              height: 'auto',
            },
            [theme.breakpoints.down('lg')]: {
              width: '100%',
              paddingTop: '12px',
            },
          },
        },
        '&.MuiAutocomplete-paper': {
          border: `1px solid ${theme.new.color.line.hairline}`,
          boxShadow: theme.new.boxShadows.elevation2,
          marginTop: '8px',

          '&&&': {
            borderRadius: '12px',
          },
        },
      },
      elevation1: {
        borderRadius: '12px',
        boxShadow: '0 0 10px rgba(12, 17, 20, 0.06)',
      },
    },
  },
});
